import React from "react";
import "./team.css";
import rituImg from "../assets/ritu-mam.jpeg";
import shriKrishanImg from "../assets/OIP.jpg.jpeg";

const leadership = [
  {
    id: 1,
    name: "Shri Krishan",
    role: "Founder & CEO",
    bio: "Retired from BEL, Ghaziabad with 40+ years of experience managing high-value radar painting projects across India.",
    avatar: shriKrishanImg,
    color: "#534AB7",
    bg: "rgba(83,74,183,0.12)",
    linkedin: "#",
  },
  {
    id: 2,
    name: "Ritu",
    role: "Director",
    bio: "Nearly a decade of experience in client management, sales & marketing strategy, and IT operations. Driven by smart work and measurable success.",
    avatar: rituImg,
    color: "#0F6E56",
    bg: "rgba(15,110,86,0.12)",
    linkedin: "#",
  },
];

const teamMembers = [
  { id: 3,  name: "Sagar Uniyal",     role: "Business Consultant" },
  { id: 4,  name: "Preeti Shukla",    role: "Recruitment Resource" },
  { id: 5,  name: "Shalu Singh",      role: "Recruitment Resource" },
  { id: 6,  name: "Kashfi Praveen",   role: "Sr. Recruitment Resource" },
  { id: 7,  name: "Ankita",           role: "Recruitment Resource" },
  { id: 8,  name: "Shiva Singh",      role: "Recruitment Resource" },
  { id: 9,  name: "Shumaila Parveen", role: "Recruitment Manager" },
  { id: 10, name: "Abhay Kumar",      role: "Business Manager" },
  { id: 11, name: "Harsh",            role: "" },
  { id: 12, name: "Seemant",          role: "Tech Support" },
  { id: 13, name: "Vickey Chauhan",   role: "Technical Head" },
];

const memberColors = [
  { color: "#534AB7", bg: "rgba(83,74,183,0.12)" },
  { color: "#0F6E56", bg: "rgba(15,110,86,0.12)" },
  { color: "#185FA5", bg: "rgba(24,95,165,0.12)" },
  { color: "#993556", bg: "rgba(153,53,86,0.12)" },
  { color: "#854F0B", bg: "rgba(133,79,11,0.12)" },
  { color: "#3C3489", bg: "rgba(60,52,137,0.12)" },
  { color: "#1D9E75", bg: "rgba(29,158,117,0.12)" },
  { color: "#BA7517", bg: "rgba(186,117,23,0.12)" },
];

const getInitials = (name) =>
  name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");

const Team = () => {
  const isStandalone = window.location.pathname === "/team";
  
  return (
    <section id="team" className={`team-page ${isStandalone ? 'standalone-page' : ''}`}>
      <div className="container">

        {/* Header */}
        <div className="team-page-header">
          <span className="team-page-badge">Our People</span>
          <h2 className="team-page-title">Meet the Team</h2>
          <p className="team-page-subtitle">
            A passionate group of professionals committed to delivering
            excellence and driving your success.
          </p>
        </div>

        {/* Leadership */}
        <p className="team-section-label">Core Management</p>
        <div className="team-leader-grid">
          {leadership.map((member) => (
            <div key={member.id} className="team-leader-card">
              <div className="team-leader-avatar-wrap">
                {member.avatar ? (
                  <img
                    src={member.avatar}
                    alt={member.name}
                    className="team-leader-avatar"
                  />
                ) : (
                  <div className="team-leader-avatar-placeholder">
                    <div
                      className="team-leader-initials"
                      style={{ background: member.bg, color: member.color }}
                    >
                      {getInitials(member.name)}
                    </div>
                  </div>
                )}
              </div>
              <div className="team-leader-body">
                <h3 className="team-leader-name">{member.name}</h3>
                <span
                  className="team-leader-role"
                  style={{ background: member.bg, color: member.color }}
                >
                  {member.role}
                </span>
                <p className="team-leader-bio">{member.bio}</p>
                {member.linkedin && member.linkedin !== "#" && (
                  <a
                    href={member.linkedin}
                    className="team-leader-linkedin"
                    style={{ color: member.color }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Team Grid */}
        <p className="team-section-label">Our Team</p>
        <div className="team-member-grid">
          {teamMembers.map((member, index) => {
            const cl = memberColors[index % memberColors.length];
            return (
              <div
                key={member.id}
                className="team-member-card"
                style={{ animationDelay: `${index * 60}ms` }}
              >
                <div
                  className="team-member-initials"
                  style={{ background: cl.bg, color: cl.color }}
                >
                  {getInitials(member.name)}
                </div>
                <div className="team-member-info">
                  <p className="team-member-name">{member.name}</p>
                  <p className="team-member-role">{member.role}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Team;
